(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('file-content', {
            parent: 'entity',
            url: '/file-content',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.fileContent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file-content/file-contents.html',
                    controller: 'FileContentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fileContent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('file-content-detail', {
            parent: 'file-content',
            url: '/file-content/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.fileContent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file-content/file-content-detail.html',
                    controller: 'FileContentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fileContent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FileContent', function($stateParams, FileContent) {
                    return FileContent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'file-content',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('file-content-detail.edit', {
            parent: 'file-content-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-dialog.html',
                    controller: 'FileContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FileContent', function(FileContent) {
                            return FileContent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('file-content.new', {
            parent: 'file-content',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-dialog.html',
                    controller: 'FileContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                contentContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('file-content', null, { reload: 'file-content' });
                }, function() {
                    $state.go('file-content');
                });
            }]
        })
        .state('file-content.edit', {
            parent: 'file-content',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-dialog.html',
                    controller: 'FileContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FileContent', function(FileContent) {
                            return FileContent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('file-content', null, { reload: 'file-content' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('file-content.delete', {
            parent: 'file-content',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-delete-dialog.html',
                    controller: 'FileContentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FileContent', function(FileContent) {
                            return FileContent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('file-content', null, { reload: 'file-content' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
